import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedZone: 1,
};

const activeMechanicalTabSlice = createSlice({
    name: 'activeMechanicalTab',
    initialState,
    reducers: {
        setSelectedZone(state, action) {
            state.selectedZone = action.payload;
        },
        clearActiveTab(state) {
            state.selectedZone = initialState.selectedZone;
        },
    },
});

export const { setSelectedZone, clearActiveTab } = activeMechanicalTabSlice.actions;

export default activeMechanicalTabSlice.reducer;